import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { Spinner } from '@components/atoms'
import { useAppDispatch, useAppSelector, authActions } from '@redux/index'

interface PropsType {
	children: JSX.Element
}

const SsoConnectionProvider = (props: PropsType) => {
	// redux dispatch
	const reduxDispatch = useAppDispatch()

	// redux state
	const isLoading: boolean = useAppSelector(state => state.config.isLoading as boolean)

	// state
	const [isPageLoading, setIsPageLoading] = React.useState<boolean>(true)

	// get query string
	const [searchParams] = useSearchParams()
	const accessToken: string | null = searchParams.get('accessToken')

	React.useEffect(() => {
		if (isLoading) {
			setIsPageLoading(false)
		}
	}, [isLoading])

	React.useEffect(() => {
		if (typeof accessToken === 'string') {
			reduxDispatch(authActions.LOGIN_USING_accessToken({ accessToken: accessToken }))
		} else {
			setIsPageLoading(false)
		}
	}, [])

	return <>{isPageLoading || isLoading ? <Spinner /> : props.children}</>
}

export default SsoConnectionProvider
